export class Articulo {

   public id: number;
   public codigoArticulo: string;
   public codigoCategoria: string;
   public codigoSubCategoria: string;
   public referenciaERP: string;
   public codigoConsorcio: string;
   public nombreCorto: string;
   public nombreLargo: string;
   public nivelFragilidad: string;
   public nivelPeligrosidad: string;
   public tipoAlmacenamiento: string;
   public codigoBarraUnidad: string;
   public codigoBarraBulto: string;
   public codigoProveedor: string;
   public unidadBase: string;
   public unidadPaquete: string;
   public unidadesPaquete: number;
   public paquetesTarima: number;
   public paquetesBaseTarima: number;
   public paquetesAlturaTarima: number;
   public pesoPaquete: number;
   public cubicajePaquete: number;
   public diasCuarentena: number;
   public gestionLote: boolean;
   public metodoRotacion: string;
   public controlSeries: boolean;
   public estado: boolean;
   public precio: number;


}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/model/articulo.ts